const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'transactions', label: 'Transacciones' },
  { id: 'settings', label: 'Configuraciones' },
];

function AppNav({ activeView, onChange }) {
  return (
    <nav
      aria-label="Navegación principal"
      className="fixed inset-x-0 top-4 z-40 px-3 sm:top-6 sm:px-4"
    >
      <div className="glass-panel mx-auto inline-flex max-w-full items-center gap-1 overflow-x-auto rounded-full p-1">
        {NAV_ITEMS.map((item) => {
          const isActive = activeView === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange(item.id)}
              aria-current={isActive ? 'page' : undefined}
              className={`whitespace-nowrap rounded-full px-3 py-2 text-[11px] font-medium tracking-tight transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300/60 sm:px-5 sm:text-xs ${isActive ? 'bg-gradient-to-br from-violet-500/90 via-violet-500/80 to-cyan-400/80 text-white shadow-glow' : 'text-white/55 hover:bg-white/[0.06] hover:text-white/85'}`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default AppNav;